import { isHasLastNameEnabled } from '../config';
import { resolveProfileFirstName } from './api';

/** Greeting / dashboard display name when `has_last_name` is false (single name field). */
export function resolveV3GreetingName(user: {
  name?: string;
  first_name?: string;
  last_name?: string;
} | null | undefined): string {
  if (!user) {
    return '';
  }
  const first = resolveProfileFirstName(user);
  if (!isHasLastNameEnabled()) {
    return first || String(user.name ?? '').trim();
  }
  const full = String(user.name ?? '').trim();
  if (full) {
    return full;
  }
  const last = user.last_name != null ? String(user.last_name).trim() : '';
  return last ? `${first} ${last}`.trim() : first;
}
